import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ISendWidgetEvent, IWidgetEventState } from './models'

export const widgetEventSlice = createSlice({
  name: 'widgetEvents',
  initialState: {} as IWidgetEventState,
  reducers: {
    sendEvent: (state, action: PayloadAction<ISendWidgetEvent>) => {
      const { widgetEvent, widgetName } = action.payload
      state[widgetName] = widgetEvent
    },
    cleanEvent: (state, action: PayloadAction<string>) => {
      delete state[action.payload]
    },
  },
})

export const { sendEvent, cleanEvent } = widgetEventSlice.actions

export const widgetEventReducer = widgetEventSlice.reducer
